export const ACTIONS = {
    UPDATE: 'UPDATE',
    UPDATE_CROP: 'UPDATE_CROP',
    UPDATE_OPTION: 'UPDATE_OPTION',
    SET_FLEXIBLE_MEDIA: 'SET_FLEXIBLE_MEDIA',
    SET_ORIGINAL_IMAGE_URL: 'SET_ORIGINAL_IMAGE_URL',
}

export const initialState = {
    aspectCropData: [
        {
            id: 'square',
            aspect: 'square',
            title: 'Square',
            ratio: '1:1',
            aspectRatio: 1 / 1,
            originalUrl: null,
            selectedOption: 'original',
            croppedImage: null,
            canvasWidth: 241,
            canvasHeight: 241,
        },
        {
            id: 'vertical',
            aspect: 'vertical',
            title: 'Vertical',
            ratio: '9:16',
            aspectRatio: 9 / 16,
            originalUrl: null,
            selectedOption: 'original',
            croppedImage: null,
            canvasWidth: 241,
            canvasHeight: 428,
        },
        {
            id: 'horizontal',
            aspect: 'horizontal',
            title: 'Horizontal',
            ratio: '1.91:1',
            aspectRatio: 1.91 / 1,
            originalUrl: null,
            selectedOption: 'original',
            croppedImage: null,
            canvasWidth: 241,
            canvasHeight: 126,
        },
    ],
    flexibleMedia: true,
}

export const mediaCropReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.UPDATE_CROP: {
            const { aspectCropId, croppedImage, croppedArea, croppedData } = action.payload
            return {
                ...state,
                aspectCropData: state.aspectCropData.map((crop) => {
                    if (crop.id === aspectCropId) {
                        return {
                            ...crop,
                            croppedImage,
                            croppedArea,
                            croppedData,
                            selectedOption: 'cropped',
                        }
                    }
                    return crop
                }),
            }
        }

        case ACTIONS.UPDATE_OPTION: {
            const { cropId, selectedOption } = action.payload
            return {
                ...state,
                aspectCropData: state.aspectCropData.map((crop) =>
                    crop.id === cropId ? { ...crop, selectedOption } : crop,
                ),
            }
        }

        case ACTIONS.SET_FLEXIBLE_MEDIA:
            return {
                ...state,
                flexibleMedia: action.payload,
            }

        case ACTIONS.UPDATE: {
            const { cropId, ...rest } = action.payload

            return {
                ...state,
                aspectCropData: state.aspectCropData.map((crop) => (crop.id === cropId ? { ...crop, ...rest } : crop)),
            }
        }

        // case ACTIONS.SET_ORIGINAL_IMAGE_URL:
        //     return {
        //         ...state,
        //         aspectCropData: state.aspectCropData.map((crop) => ({ ...crop, originalUrl: action.payload })),
        //     }

        default:
            return state
    }
}
